import axiosInstance from './axiosInstance';

/**
 * Sends a page log to the backend.
 * @param {string} pagename - The name of the page (e.g., 'home', 'publication-details').
 * @param {string} [token] - Optional authentication token.
 * @returns {Promise<any>}
 */
export const sendPageLog = async (pagename, token) => {
  try {
    const config = {};
    if (token) {
      config.headers = { Authorization: `Bearer ${token}` };
    }
    
    const response = await axiosInstance.post(
      'systemsettings/sendPageLog',
      { pagename },
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error sending page log:', error);
    // Silent fail to not disrupt user experience
    return null;
  }
};

const systemSettingsService = {
  sendPageLog,
};

export default systemSettingsService;
